import api from '../../helpers/axios'

export const state = {
    question: null,
    questions: [],
    courseId: null, // Başlangıçta null olarak ayarlayın veya başka bir değerle başlatın
    props: {
        courseId: String,
        examId: String,
        contentId: String,
    },
};

export const getters = {
    question: (state) => state.question,
    questions: (state) => state.questions,
};

export const mutations = {
    setQuestion(state, newValue) {
        state.question = newValue;
    },
    setQuestions(state, newValue) {
        state.questions = newValue;
    },
    setCourseId(state, newValue) {
        state.courseId = newValue;
    },
    setExamId(state, newValue) {
        state.examId = newValue;
    },
};
export const actions = {

    createQuestion(_, { data, courseId, examId }) {
        return new Promise((resolve, reject) => {
            /* eslint-disable */
            console.log(courseId, examId);
            api.post(`/courses/${courseId}/exams/${examId}/questions`, data)
                .then((res) => {
                    if (res) {
                        resolve(res.data.data);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateQuestion(_, {courseId, examId,questionId, data }) {
        return new Promise((resolve, reject) => {
            api.put(`/courses/${courseId}/exams/${examId}/questions/` + questionId, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    deleteQuestion(_, {examId, courseId, questionId}) {
        return new Promise((resolve) => {
            api.delete(`/courses/${courseId}/exams/${examId}/questions/` + questionId).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchQuestion({ commit }, { examId }) {
        return new Promise((resolve, reject) => {
            api.get("/questions/" + examId).then((res) => {
                commit("setQuestions", res.data.data);
                resolve(res.data.data);
            }).catch(err => {
                reject(err);
            });
        });
    },


    fetchQuestions({ commit }, { name, type,courseId,examId, description, isActive, page, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        if (name) {
            query += `name=${name}&`;
        }

        if (type) {
            query += `type=${type}&`;
        }

        if (description) {
            query += `description=${description}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get(`/courses/${courseId}/exams/${examId}/questions` + query ).then((res) => {
                commit("setQuestions", res.data.data);
                resolve(res.data.data);
            });
        });
    }
};
